<template>
  <div>
    <div @click="openMask" class="card-body"
         v-bind:videoId="video.id"
         v-bind:title="video.url"
         v-bind:description="video.title"
         v-bind:duration="video.duration"
    >
      <h5 class="card-title">
        {{ video.url }}
      </h5>
      <!-- h6
        class="card-subtitle mb-2 text-muted"
      >{{ video.snippet.channelTitle }} | {{ video.snippet.publishedAt | formatDate }}</h6 -->
      <p class="card-text">{{ video.title }}</p>
    </div>
    <dialog-bar v-model="sendVal"
                type="confirm"
                v-bind:title="video.url"
                v-bind:content="video.title"
                v-bind:videoId="video.id"
                v-bind:duration="video.duration"
                v-on:cancel="clickCancel" @danger="clickDanger" @confirm="clickConfirm"></dialog-bar>
  </div>
</template>

<script>
import axios from "axios";
import dialogBar from "./layout/dialog.vue";

export default {
  name: 'VideoListItem',
  props: ['video','placeKey','roomNo'],
  components:{
    'dialog-bar': dialogBar,
  },
  data(){
    return{
      sendVal: false,
    }
  },
  methods: {
    /*
    clickVideo(videoId,title,description) {
      //console.log("videoId:"+videoId+" description:"+description);
      let res = confirm('确定点播？\n'+title);
      if(res == true) {
        console.log('点击了确认');
        let apiUrl = "https://xqsmobile.echoktv.net/api/ytb/videoClickPost";
        let data = {"placeKey":this.placeKey,"roomNo":this.roomNo,"videoId":videoId,"title":title,"description":description};
        axios
            .post(apiUrl,data)
            .then(res => {
              //this.videos = res.data.data.items;
              if(res.data.code == 1201 || res.data.code == 1002) {
                alert("出错了:"+res.data.message);
              }
              else {
                alert("点播成功");
              }
            })
            .catch(error => {
              console.log(error);
              alert("出错了:"+error);
            });
      }else{
        console.log('点击了取消');
      }
    },
    */
    openMask(){
      this.sendVal = true;
    },
    clickCancel(){
      console.log('点击了取消');
    },
    clickDanger(){
      console.log('这里是danger回调');
    },
    clickConfirm(data){
      console.log('点击了confirm:videoId='+data.videoId);
      console.log('点击了confirm:title='+data.title);
      console.log('点击了confirm:content='+data.content);
      console.log('点击了confirm:duration='+data.duration);
      console.log('点击了confirm:trackid='+data.trackid);
      console.log('点击了confirm:first='+data.first);
      console.log('点击了confirm:key='+data.key);
      // let apiUrl = "https://xqsmobile.echoktv.net/api/ytb/videoClickPost"; //正式环境
      let apiUrl = "https://mlserver.goodtimektv.com/api/ytb/videoClickPost"; //测试环境
      let sendData = {"placeKey":this.placeKey,
        "roomNo":this.roomNo,
        "videoId":data.videoId,
        "title":data.title,
        "description":data.content,
        "duration":data.duration,
        "trackid":data.trackid,
        "first":data.first,
        "key":data.key};
      axios
          .post(apiUrl,sendData)
          .then(res => {
            //this.videos = res.data.data.items;
            if(res.data.code == 1201 || res.data.code == 1002) {
              alert("出错了:"+res.data.message);
            }
            else {
              alert("点播成功");
            }
          })
          .catch(error => {
            console.log(error);
            alert("出错了:"+error);
          });
    }
  },
};
</script>
